import { useEffect, useState } from "react";
import { useT } from "../../i18n/I18nProvider";

// Inline confirm-then-delete button. window.confirm() is unreliable inside
// iframes (some hosts strip allow-modals or treat it as user-disturbed and
// silently return false), so we show a one-second inline confirm step
// instead — one click arms it, a second click within the timeout actually
// triggers onDelete.
export function ConfirmDeleteButton({
  onDelete,
  hint,
  disabled,
}: {
  onDelete: () => void | Promise<void>;
  hint?: string;
  disabled?: boolean;
}) {
  const t = useT();
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    if (!armed) return;
    const id = setTimeout(() => setArmed(false), 4000);
    return () => clearTimeout(id);
  }, [armed]);

  if (!armed) {
    return (
      <button type="button" onClick={() => setArmed(true)} disabled={disabled} title={hint}>
        {t("common.delete")}
      </button>
    );
  }

  return (
    <span style={{ display: "inline-flex", gap: 6 }}>
      <button
        type="button"
        onClick={async () => {
          setArmed(false);
          await onDelete();
        }}
        style={{ background: "var(--danger)", color: "#fff", borderColor: "var(--danger)" }}
        title={hint}
      >
        {t("common.confirmDelete")}
      </button>
      <button type="button" onClick={() => setArmed(false)}>
        {t("common.cancel")}
      </button>
    </span>
  );
}
